import type { Equals } from '../types'

type OnError = (error: any, firstTime?: boolean) => void

export function eq(a?: any, b?: any): boolean {
  return a === b
}
export function safeEq(eq?: undefined): undefined
export function safeEq(eq: Equals): Equals
export function safeEq(eq?: Equals): Equals | undefined

export function safeEq(arg?: Equals | undefined): Equals | undefined {
  if (arg === undefined || arg === eq) return arg
  return (a, b) => {
    try {
      return arg(a, b)
    } catch {
      return false
    }
  }
}

export function safeOnError(onError?: undefined): undefined
export function safeOnError(onError: OnError): OnError
export function safeOnError(onError?: OnError): OnError | undefined
export function safeOnError(arg?: OnError): OnError | undefined {
  if (arg === undefined) return arg
  return (error: any, firstTime?: boolean) => {
    try {
      return arg(error, firstTime)
    } catch {}
  }
}
